const SCRIPT_URL = 'https://a.usbrowserspeed.com/cs?pid=ddae2e0bce828a30a7b24f94f87290780f71120eaf9f11353f234c3bd86512d3&puid=%7B%22userId%22%3A%226ac6ea3e43fcfd987b8c2c04%22%2C%22env%22%3A%22prod%22%7D';
let loadedPath: string | undefined;
export const fuseVisitorsLoaded = () => loadedPath !== undefined;
export const fuseVisitorsNeedsNavigation = () => loadedPath !== undefined && window.location.pathname !== loadedPath;
/** Called after resolving the account preference, only for signed-out acquisition visits. */
export function startFuseVisitors(hasOptedOut: () => boolean, signedOut: boolean): void {
  try {
    if (loadedPath || !signedOut || import.meta.env.MODE !== 'production'
      || window.location.origin !== 'https://userill.dev'
      || !['/', '/pricing', '/freebuff'].includes(window.location.pathname)
      || hasOptedOut() || (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl
      || /(?:^|;\s*)rill_analytics_enabled=0(?:;|$)/.test(document.cookie)) return;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = SCRIPT_URL;
    script.async = true;
    script.referrerPolicy = 'no-referrer';
    loadedPath = window.location.pathname;
    document.head.appendChild(script);
  } catch { /* Tracking must never prevent rendering or sign-in. */ }
}
